export const editActionNames = {
  changeFromDate: 'changeFromDate',
  changeToDate: 'changeToDate',
  setRoomsFromDate: 'setRoomsFromDate',
  changeMainData: 'changeMainData',
  changeDesksSettings: 'changeDesksSettings',
};
